/* eslint-disable no-unused-vars */
import React from 'react';
import classnames from 'classnames';
import _ from 'underscore';
import { submitEvent } from '@bingads-webui-universal/accessibility-helper';

export type IToggleOnChange = (newChecked: boolean) => void;

export interface IToggleProps {
  checked?: boolean;
  className?: string;
  disabled?: boolean;
  id?: string;
  name?: string;
  label?: string;
  onChange: IToggleOnChange;
}

export interface IToggleState {
  isChecked: boolean;
}

/*  eslint-disable jsx-a11y/no-noninteractive-tabindex */
export class Toggle extends React.PureComponent<IToggleProps, IToggleState> {
  static defaultProps: Partial<IToggleProps> = {
    checked: false,
    className: 'toggle',
    label: 'toggle',
    disabled: false,
    id: null,
    name: null,
  };

  constructor(props: IToggleProps) {
    super(props);
    this.state = { isChecked: props.checked || false };
  }

  // if checked updated externally, update the state
  componentDidUpdate(prevProps: IToggleProps) {
    if (this.props.checked !== prevProps.checked || this.props.checked !== this.state.isChecked) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ isChecked: !!this.props.checked });
    }
  }

  onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => this.props.onChange(event.target.checked);

  onChange = () => {
    this.setState(
      (state: IToggleState) => ({
        isChecked: !state.isChecked,
      }),
      () => this.props.onChange(this.state.isChecked)
    );
  };

  render() {
    const {
      name, disabled, className, label,
    } = this.props;
    const { id = _.uniqueId('toggle-') } = this.props;
    return (
      <label className={classnames('switch', className)} htmlFor={id}>
        <input
          type="checkbox"
          id={id}
          name={name}
          checked={this.state.isChecked}
          disabled={disabled}
          onChange={this.onInputChange}
        />
        <span
          className="slider round"
          tabIndex={0}
          role="switch"
          aria-checked={this.state.isChecked}
          aria-label={label}
          onKeyDown={event => submitEvent(this.onChange)(event, event)}
        />
      </label>
    );
  }
}
